import React from 'react'
import PropTypes from 'prop-types'

const InputWrapper = ({
  label,
  helperText,
  errorText,
  input,
  style,
  topSpacing,
  bottomSpacing,
}) => (
  <div
    className={`w-full mt-${topSpacing * 2} mb-${bottomSpacing * 2}`}
    style={style}
  >
    {Boolean(label) && (
      <p className="text-xl text-left text-gray-700 mb-1" variant="h6">
        {label}
      </p>
    )}
    {input}
    {Boolean(helperText) && (
      <p variant="body2" className="text-sm mt-2 text-left text-gray-600">
        {helperText}
      </p>
    )}
    {Boolean(errorText) && (
      <p className="text-base mt-1 text-red-700">{errorText}</p>
    )}
  </div>
)

InputWrapper.defaultProps = {
  errorText: '',
  helperText: null,
  label: undefined,
  style: {},
  topSpacing: 0,
  bottomSpacing: 2,
}

InputWrapper.propTypes = {
  errorText: PropTypes.string,
  helperText: PropTypes.any,
  label: PropTypes.any,
  input: PropTypes.node.isRequired,
  style: PropTypes.object,
  topSpacing: PropTypes.number, // used in styles
  bottomSpacing: PropTypes.number,
}

export default InputWrapper
